import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../utils/axiosSetup.js';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { closeModal } from '../../../action/modalbehaviour.js';
import { calculateTotalTime, validateTime } from '../../../action/timeCalculation.jsx';


const AddTimeLog = ({projectId, list}) => {
    const navigate = useNavigate();
    const [projectData, setProjectData] = useState(null);
    const [tasktypes, setTaskTypes] = useState(null);
    const [teamLeads, setTeamLeads] = useState([]);
    const [meter, setMeter] = useState([]);
    const [getChannel, setChannel] = useState('');
    const [getMeterType, setMeterType] = useState('');

    const [timeSpendHours, setTimeSpendHours] = useState('');
    const [timeSpendMinutes, setTimeSpendMinutes] = useState('');
    const [billableHours, setBillableHours] = useState('');
    const [billableMinutes, setBillableMinutes] = useState('');
    const [nonBillableHours, setNonBillableHours] = useState('');
    const [nonBillableMinutes, setNonBillableMinutes] = useState('');
    const [timeSpendTotal, setTimeSpendTotal] = useState('');

    const fetchProjectData = async (projectId) => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/get_project_timelog?projectId=${projectId}`)
            .then(response => {
                setProjectData(response.data.data);
                setTaskTypes(response.data.data.task_types);
                setMeter(response.data.data.meter);
                setChannel(response.data.data.channel);
            })
            .catch(error => {
                console.error('Error fetching project details', error);
                setProjectData([]);
                setTaskTypes([]);
                setMeter([]);
            });
    }

    const fetchTeamLead = async () => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/users?users=teamleads`)
            .then(response => {
                setTeamLeads(response.data.data);
            })
            .catch(error => {
                console.error('Error fetching teamleads', error);
                setTeamLeads([]);
            });
    };

    useEffect(() => {
        if (projectId) {
            fetchProjectData(projectId);
        }
        fetchTeamLead();
    }, [projectId]);


    useEffect(() => {
        const Total = calculateTotalTime(timeSpendHours, timeSpendMinutes);
        setTimeSpendTotal(Total);
    }, [timeSpendHours, timeSpendMinutes]);

    // VALIDATION RULES
    const schema = Yup.object().shape({
        time_log_date: Yup.string().required('date is a required field'),
        task_type_id: Yup.string().required('task type is a required field'),
        time_spend: Yup.string().when('$timelog', {
            is: value => value === '' || value === 0,
            then: () => Yup.string().required('time spent is a required field'),
        }),
        meter_id: Yup.string().when('$channel', {
            is: 'Upwork',
            then: () => Yup.string().required('meter is a required field'),
        })
        // time_spend: Yup.string().matches(
        //                 /^(0?[0-8]):[0-5]?[0-9]$/, 'time spent must be 9 hours or earlier')
        //             .required('time spent is a required field')
    });

    const { register, handleSubmit, formState: { errors }, reset } = useForm({
        mode: 'all',
        resolver: yupResolver(schema),
        context: { channel: getChannel, timelog: timeSpendTotal}
    });
    
    useEffect(() => {
        if (projectData) {
            reset(projectData);
        }

        const modalElement = document.getElementById(`add_timelog_${projectId}`);

        const handleClose = () => {
            reset();
            setMeterType();
            setTimeSpendHours('');
            setTimeSpendMinutes('');
            setBillableHours('');
            setBillableMinutes('');
            setNonBillableHours('');
            setNonBillableMinutes('');
            setTimeSpendTotal('');
        }

        if (modalElement) {
            modalElement.addEventListener('hidden.bs.modal', handleClose);
        }
        return () => {
            if (modalElement) {
                modalElement.removeEventListener('hidden.bs.modal', handleClose);
            }
        };
    }, [projectData, reset, projectId]);

    //CHECK METER IS HOURLY OR FIXED
    const handleMeterChange = async (meter) => {
        try {
            var project = document.getElementById('project_id').value;

            const response = await axiosInstance.post(`${process.env.REACT_APP_API_URL}/check_meter`, {
                meter_id       : meter,
                project_id     : project,
            });

            const jsonData = response.data;
            setMeterType(jsonData.success === true ? jsonData.data : 'Hourly');
        }
        catch (error) {
            console.log(error.message);                
        }
    }

    const onSubmit = async (data) => {
        if (!validateTime(timeSpendHours, timeSpendMinutes, billableHours, billableMinutes, nonBillableHours, nonBillableMinutes)) {
            Swal.fire({ text: 'Total time spent must equal the sum of billable and non-billable time.', icon: 'error' });
            return;
        }
        
        axiosInstance.post(`${process.env.REACT_APP_API_URL}/add_timelog`, data)
            .then(response => {
                Swal.fire({ icon:"success", text:response.data.message});
                closeModal(`add_timelog_${projectId}`);
                reset();
                list();

                navigate('/timelog');
            })
            .catch(({response:{data}})=>{
                Swal.fire({text:data.message, icon:"error"});
                console.error('Error creating time log', data);
            });
    }
    
    if (!projectId || !projectData) {
        return null;
    }

    const labelText = getChannel === 'Upwork' ? (getMeterType === 'Fixed' ? 'Fixed ': ' ') : 'Fixed ';

    return (
        <div id={`add_timelog_${projectId}`} className="modal custom-modal fade" role="dialog">
            <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Add Time</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="row">

                                <input type="hidden" value={projectData.project_id} id="project_id" {...register('project_id')}/>
                                <input type="hidden" value={getChannel} {...register('channel')}/>

                                <div className="col-md-4">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Channel</label>
                                        <select className="form-control" disabled>
                                            <option value={getChannel}>{getChannel}</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Client</label>
                                        <select className="form-control" disabled>
                                            <option value={projectData.client}>{projectData.client}</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Project</label>
                                        <select className="form-control" disabled>
                                            <option value={projectData.project}>{projectData.project}</option>
                                        </select>
                                    </div>
                                </div>
                                
                                { getChannel === 'Upwork' &&
                                    <div className={getChannel === 'Upwork' ? 'col-sm-4' : 'col-sm-6'}>
                                        <div className="input-block mb-3">
                                            <label className="col-form-label">Meter <span className="text-danger">*</span></label>
                                            <select className="form-control" {...register('meter_id')} onChange={e => handleMeterChange(e.target.value)}>
                                                <option value="">Select Meter</option>
                                                {meter.map(met => (
                                                    <option key={met.id} value={met.id}>{met.name}</option>
                                                ))}
                                            </select>
                                            <div className="text-sm text-danger">
                                                {errors.meter_id && <p>{errors.meter_id.message}</p>}
                                            </div>
                                        </div>
                                    </div>
                                }

                                <div className={getChannel === 'Upwork' ? 'col-sm-4' : 'col-sm-6'}>
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Task Type <span className="text-danger">*</span></label>
                                        <select className="form-control" {...register('task_type_id')}>
                                            <option value="">Select Task Type</option>
                                            {tasktypes.map(task => (
                                                <option key={task.id} value={task.id}>{task.title}</option>
                                            ))}
                                        </select>
                                        <div className="text-sm text-danger">
                                            {errors.task_type_id && <p>{errors.task_type_id.message}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className={getChannel === 'Upwork' ? 'col-sm-4' : 'col-sm-6'}>
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Date <span className="text-danger">*</span></label>
                                        <input className="form-control" type="date" {...register('time_log_date')} />
                                        <div className="text-sm text-danger">
                                            {errors.time_log_date && <p>{errors.time_log_date.message}</p>}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-12">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Time Spend <span className="text-danger">*</span></label>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="row">
                                                    <div className="col-sm-3">
                                                        <span className="form-text text-muted">Hours</span>
                                                        <select className="form-control form-control-sm" {...register('time_spend')} onChange={e => setTimeSpendHours(e.target.value)}>
                                                            <option value="">00</option>
                                                            <option value="01">01</option>
                                                            <option value="02">02</option>
                                                            <option value="03">03</option>
                                                            <option value="04">04</option>
                                                            <option value="05">05</option>
                                                            <option value="06">06</option>
                                                            <option value="07">07</option>
                                                            <option value="08">08</option>
                                                            <option value="09">09</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-sm-3">
                                                        <span className="form-text text-muted">Minute</span>
                                                        <select className="form-control form-control-sm" {...register('time_minutes')} onChange={e => setTimeSpendMinutes(e.target.value)}>
                                                            <option value="00">00</option>
                                                            <option value="17">10</option>
                                                            <option value="33">20</option>
                                                            <option value="50">30</option>
                                                            <option value="67">40</option>
                                                            <option value="83">50</option>
                                                        </select>
                                                    </div>
                                                    <div className="text-sm text-danger">
                                                        {errors.time_spend && <p>{errors.time_spend.message}</p>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-6">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">{labelText} Billable Time <span className="text-danger">*</span></label>
                                        <div className="row">
                                            <div className="col-sm-3">
                                                <span className="form-text text-muted">Hours</span>
                                                <select className="form-control form-control-sm" {...register('billable_time')} onChange={e => setBillableHours(e.target.value)}>
                                                    <option value="">00</option>
                                                    <option value="01">01</option>
                                                    <option value="02">02</option>
                                                    <option value="03">03</option>
                                                    <option value="04">04</option>
                                                    <option value="05">05</option>
                                                    <option value="06">06</option>
                                                    <option value="07">07</option>
                                                    <option value="08">08</option>
                                                    <option value="09">09</option>
                                                </select>
                                            </div>
                                            <div className="col-sm-3">
                                                <span className="form-text text-muted">Minute</span>                                                
                                                <select className="form-control form-control-sm" {...register('billable_minutes')} onChange={e => setBillableMinutes(e.target.value)} >
                                                    <option value="00">00</option>
                                                    <option value="17">10</option>
                                                    <option value="33">20</option>
                                                    <option value="50">30</option>
                                                    <option value="67">40</option>
                                                    <option value="83">50</option>
                                                </select>
                                            </div>
                                        </div>                                        
                                    </div>
                                </div>

                                <div className="col-sm-6">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Non Billable Time </label>
                                        <div className="row">
                                            <div className="col-sm-3">
                                                <span className="form-text text-muted">Hours</span>
                                                <select className="form-control form-control-sm" {...register('nonbillable_time')} onChange={e => setNonBillableHours(e.target.value)} >
                                                    <option value="">00</option>
                                                    <option value="01">01</option>
                                                    <option value="02">02</option>
                                                    <option value="03">03</option>
                                                    <option value="04">04</option>
                                                    <option value="05">05</option>
                                                    <option value="06">06</option>
                                                    <option value="07">07</option>
                                                    <option value="08">08</option>
                                                    <option value="09">09</option>
                                                </select>
                                            </div>
                                            <div className="col-sm-3">
                                                <span className="form-text text-muted">Minute</span>
                                                <select className="form-control form-control-sm" {...register('nonbillable_minutes')} onChange={e => setNonBillableMinutes(e.target.value)}>
                                                    <option value="00">00</option>
                                                    <option value="17">10</option>
                                                    <option value="33">20</option>
                                                    <option value="50">30</option>
                                                    <option value="67">40</option>
                                                    <option value="83">50</option>
                                                </select>
                                            </div>
                                        </div>                                        
                                    </div>
                                </div>

                                <div className="col-sm-6">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">{labelText} Billable Description <span className="text-danger">*</span></label>
                                        <textarea className="form-control" defaultValue={projectData.billable_description || ""} {...register('billable_description')} rows={3}></textarea>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Non Billable Description </label>
                                        <textarea className="form-control" defaultValue={projectData.nonbillable_description || ""} {...register('nonbillable_description')} rows={3}></textarea>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Select Manager/Team Lead</label>
                                        <select className="form-control" {...register('task_incharge')}>
                                            <option value="">Select Manager/Team Lead</option>
                                            {teamLeads.map(tl => (
                                                <option key={tl.id} value={tl.id}>{tl.name} ({tl.designation})</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>                                
                            </div>
                            <div className="submit-section">
                                <button type="submit" className="btn btn-primary submit-btn">SUBMIT</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddTimeLog